module.exports = __webpack_public_path__ + "assets/img/2003-vi.svg";